export default __webpack_public_path__ + "static/media/calender.88a89287.svg";